import React, { useState, useEffect } from 'react';
import { fetchFees, fetchDiscounts, fetchProfile as fetchProfileAPI } from '../utils/api';
import CreateFeeModal from './CreateFeeModal';
import CreateDiscountModal from './CreateDiscountModal';
import EditFeeModal from './EditFeeModal';
import EditDiscountModal from './EditDiscountModal';
import { ADMIN_ROLE, FINANCIAL_STAFF } from '../utils/roles';
import './FeesAndDiscounts.css';
import './_Buttons.css';

const FeesAndDiscounts = () => {
    const [fees, setFees] = useState([]);
    const [discounts, setDiscounts] = useState([]);
    const [isFeeModalOpen, setFeeModalOpen] = useState(false);
    const [isDiscountModalOpen, setDiscountModalOpen] = useState(false);
    const [isEditFeeModalOpen, setEditFeeModalOpen] = useState(false);
    const [isEditDiscountModalOpen, setEditDiscountModalOpen] = useState(false);
    const [selectedFee, setSelectedFee] = useState(null);
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const [profile, setProfile] = useState(null);

    useEffect(() => {
        const loadData = async () => {
            try {
                const profileData = await fetchProfileAPI();
                setProfile(profileData.data);
                fetchFeesData();
                fetchDiscountsData();
            } catch (error) {
                console.error('Error loading data:', error);
            }
        };

        loadData();
    }, []);

    const fetchFeesData = async () => {
        try {
            const response = await fetchFees();
            setFees(response.data);
        } catch (error) {
            console.error('Error fetching fees:', error);
        }
    };

    const fetchDiscountsData = async () => {
        try {
            const response = await fetchDiscounts();
            setDiscounts(response.data);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const handleEditFee = (fee) => {
        setSelectedFee(fee);
        setEditFeeModalOpen(true);
    };

    const handleEditDiscount = (discount) => {
        setSelectedDiscount(discount);
        setEditDiscountModalOpen(true);
    };

    const canManage = profile && profile.roles.some(role => role.id === ADMIN_ROLE || role.id === FINANCIAL_STAFF);

    return (
        <div className="fees-discounts-container">
            {canManage && isFeeModalOpen && <CreateFeeModal closeModal={() => setFeeModalOpen(false)} refreshData={fetchFeesData} />}
            {canManage && isDiscountModalOpen && <CreateDiscountModal closeModal={() => setDiscountModalOpen(false)} refreshData={fetchDiscountsData} />}
            {canManage && isEditFeeModalOpen && <EditFeeModal closeModal={() => setEditFeeModalOpen(false)} refreshData={fetchFeesData} fee={selectedFee} />}
            {canManage && isEditDiscountModalOpen && <EditDiscountModal closeModal={() => setEditDiscountModalOpen(false)} refreshData={fetchDiscountsData} discount={selectedDiscount} />}

            <div className="lss-section">
                <div className="header-container">
                    <h2>Fees</h2>
                    {canManage && <button onClick={() => setFeeModalOpen(true)} className="add-student-button">+</button>}
                </div>
                <table className="policies-table fees-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Amount</th>
                            {canManage && <th>Actions</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {fees.map((fee, index) => (
                            <tr key={fee.id}>
                                <td>{index + 1}</td>
                                <td>{fee.name}</td>
                                <td>{fee.description}</td>
                                <td>${(fee.amount / 100).toFixed(2)}</td>
                                {canManage && <td>
                                    <button onClick={() => handleEditFee(fee)} className="cancel-button text-button">Edit</button>
                                </td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="lss-section">
                <div className="header-container">
                    <h2>Discounts</h2>
                    {canManage && <button onClick={() => setDiscountModalOpen(true)} className="add-student-button">+</button>}
                </div>
                <table className="policies-table discounts-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Amount</th>
                            {canManage && <th>Actions</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {discounts.map((discount, index) => (
                            <tr key={discount.id}>
                                <td>{index + 1}</td>
                                <td>{discount.name}</td>
                                <td>{discount.description}</td>
                                <td>{discount.type == 'Fixed' ? `$${(discount.amount / 100).toFixed(2)}`: `${discount.amount / 100}%`}</td>
                                {canManage && <td>
                                    <button onClick={() => handleEditDiscount(discount)} className="cancel-button text-button">Edit</button>
                                </td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FeesAndDiscounts;
